export default "__VITE_ASSET__BnaNwbtc__"